import { forwardRef, useState, createElement } from 'react';

import { makeStyles } from '@gogame/ui/styles';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      flex: 1,
      position: 'relative',
      minHeight: 400,
      // '& ::-webkit-scrollbar': {
      //   background: theme.palette.background.paper + '!important',
      // },
      // '& ::-webkit-scrollbar-track:vertical': {
      //   borderLeft: ({ hasRows }) =>
      //     hasRows ? `1px solid ${theme.palette.divider}` : 'none',
      // },
      // '& ::-webkit-scrollbar-track:horizontal': {
      //   borderTop: ({ hasRows }) =>
      //     hasRows ? `1px solid ${theme.palette.divider}` : 'none',
      // },
    },
    holder: {
      position: 'absolute',
      inset: 0,
      display: 'flex',
      flexFlow: 'column',
      // background: 'red'
    },
  }),
  { name: 'DataGridContainer' }
);
const defaultContainerComponent = ({
  withColorScale: _,
  children,
  ...props
}) => <div {...props}>{children}</div>;

export const Container = forwardRef(({ children }, ref) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.holder} ref={ref}>
        {children}
      </div>
    </div>
  );
});
Container.displayName = 'Container';

export default Container;
